var itoptima = itoptima || {};
( function () {
    'use strict';
    jQuery( window ).on( 'load', function () {
        itoptima.init();
    } );
    itoptima.init = function () {
        itoptima.scrollPosition.init();
//        itoptima.changeBackgroundColor.init();
    };
//    itoptima.changeBackgroundColor = {
//        init: function () {
//            itoptima.changeBackgroundColor.bind()
//        },
//        bind: function () {
//            var scrollPosition = 0;
//            jQuery( window ).on( 'scroll', function () {
//                scrollPosition = jQuery( window ).scrollTop();
//                if (scrollPosition > 2500) {
//                    jQuery('.e-content, .e-header').css('background-color', "#fff2e4" );
//                } else {
//                    jQuery('.e-content, .e-header').css('background-color', "#ffffff" );
//                }
//            });
//        }
//    };
    itoptima.scrollPosition = {
        init: function () {
            itoptima.scrollPosition.bind()
        },
        bind: function () {
            itoptima.scrollPosition.isRAF = false;
            jQuery( window ).on( 'scroll', function () {
                if ( itoptima.scrollPosition.isRAF === false ) {
                    window.requestAnimationFrame( function () {
                        itoptima.scrollPosition.textScrollPosition();
                        itoptima.scrollPosition.isRAF = false;
                    } );
                    itoptima.scrollPosition.isRAF = true;
                }
            } );
        },
        isInViewport: function ( node ) {
            var rect = node.getBoundingClientRect();
            return ( ( rect.height > 0 || rect.width > 0 ) && rect.bottom >= 0 && rect.right >= 0 && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) && rect.left <= ( window.innerWidth || document.documentElement.clientWidth ) )
        },
        textScrollPosition: function () {
            var scrolled = $( window ).scrollTop();
            var intWindowWidth = jQuery( window ).width();
            jQuery( '[class*="itoptima-scroll-"]' ).each( function ( index, element ) {
                var initY = jQuery( this ).offset().top;
                var height = 1000;
                var visible = itoptima.scrollPosition.isInViewport( this );
                    if ( visible ) {
                        if ( intWindowWidth > e4.settings.breakpoint.lg ) {
                        var diff = scrolled - initY;
                        var ratio1 = Math.round( ( diff / height ) * 125 );
                        jQuery( this ).css( 'transform', 'translateY(' + parseInt( ( -ratio1 ) ) + 'px' );
                    }
                }
            } );
        }
    };
}() );
